<template>
  <div class="LegalesListado">
    <div v-if="isOnline">
      <md-table
        v-model="filtroLegales"
        md-sort="nombre_usr"
        md-sort-order="asc"
        md-fixed-header
        md-card
      >
        <md-table-toolbar>
          <div class="md-toolbar-section-start md-title">Documentos legales registrados</div>
          <div class="md-toolbar-section-end">
            <md-field md-clearable>
              <md-input
                placeholder="Buscar..."
                v-model="buscar"
              />
            </md-field>
            <md-button
              class="md-icon-button"
              to="/legal"
            >
              <md-icon>add</md-icon>
            </md-button>
          </div>
        </md-table-toolbar>
        <md-table-row
          slot="md-table-row"
          slot-scope="{ item }"
          class="upper"
        >
          <md-table-cell
            md-label="Documento"
            md-sort-by="titulo_leg"
          >
            {{item.titulo_leg}}
          </md-table-cell>
          <md-table-cell
            md-label="Tipo"
            md-sort-by="tipo_leg"
          >
            {{item.titulo_leg}}
          </md-table-cell>
          <md-table-cell md-numeric>
            <md-button
              class="md-icon-button md-dense"
              :to="`/legal/${item.id}`"
            >
              <md-icon>edit</md-icon>
            </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>
      <Loading v-if="cargando" />
    </div>
    <InternetRequired v-else />
  </div>
</template>
<script>
const toLower = text => {
  return text.toString().toLowerCase();
};
const buscarUsr = (items, term) => {
  if (term) {
    return items.filter(item =>
      toLower(item.descripcion).includes(toLower(term))
    );
  }
  return items;
};
import Loading from "@/components/Loading";
import InternetRequired from "@/components/InternetRequired";
export default {
  name: "LegalesListado",
  components: { Loading, InternetRequired },
  methods: {
    buscarEnLaTabla() {
      this.filtroLegales = buscarUsr(this.motivos, this.buscar);
    },
    _falloResponse(err) {
      this.cargando = false;
      if (err.status === 401) {
        this.$router.push("/login");
      } else {
        this.$emit("msg", this.$no_internet);
      }
    },
    _obtenerLegales() {
      this.cargando = true;
      this.$http.get("legal", this.$headers).then(
        res => {
          this.cargando = false;
          if (res.status === 401) {
            this.$router.push("/login");
          } else if (res.status === 200 && "legal" in res.body) {
            this.legal = res.body.legal;
          } else {
            this.$emit(
              "msg",
              "Sucedió un error al obtener los motivos. Inténtelo de nuevo."
            );
          }
        },
        err => this._falloResponse(err)
      );
    }
  },
  data() {
    return {
      buscar: null,
      filtroLegales: [],
      legal: [],
      cargando: false
    };
  },
  watch: {
    legal() {
      this.filtroLegales = this.legal;
    },
    buscar(a) {
      this.buscarEnLaTabla();
    }
  },
  created() {
    this._obtenerLegales();
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$emit("visible", false);
      this.$router.push("/login");
    } else {
      this.$emit("visible", true);
      this.$emit("classes", "container");
    }
  }
};
</script>